import { apiClient, handleResp } from './utils'
export default {
  login,
  logout,
  getChurchProfile
}

function login(email, password) {
  return handleResp(
    apiClient().post('/users/authenticate', {
      auth: {
        email,
        password
      }
    })
  )
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
}

function getChurchProfile() {
  return handleResp(apiClient().post('/lookup_profile'))
}
